export default {
  item: (state) => state.item,
  loading: (state) => state.loading
};
